























































import {Component, Vue, Watch} from 'vue-property-decorator';
import RegisterService from '../services/RegisterService';

@Component
export default class Login extends Vue {
  private loading: boolean = false;
  private email: string = '';
  private password: string = '';
  private error: string = '';
  private e1: boolean = true;
  private snackbar: boolean = false;
  private snackbarText: string = '';
  private snackbarColor: string = '';

  @Watch('$route', {immediate: true})
  private setToken(to: any) {
      if (to.query.token && to.query.role && to.query.id) {
        localStorage.setItem('token', to.query.token);
        localStorage.setItem('user', JSON.stringify({role: to.query.role, id: to.query.id}));
        this.$router.replace('/');
      }
  }

  private async login() {
    try {
      this.loading = true;
      const response = await RegisterService.login({
          email: this.email,
          password: this.password
      });
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
      await this.$store.dispatch('initData');
      this.$router.replace('/');
    } catch (e) {
      this.displaySnackbar(e.message, 'error');
    } finally {
      this.loading = false;
    }
  }

  private displaySnackbar(msg: string, color: string) {
    this.snackbarText = msg;
    this.snackbarColor = color;
    this.snackbar = true;
  }
}
